import { default as Endpoint } from '../../api/Endpoint';
import * as Constants from '../constants';

export function clearDataExtensionStatus() {
  return {
    type: Constants.CLEAR_DATA_EXTENSION_STATUS
  };
}

export function requestDataExtensions() {
  return {
    type: Constants.REQUEST_DATA_EXTENSIONS
  };
}
export function receiveDataExtensions(json, error) {
  return {
    type: Constants.RECEIVE_DATA_EXTENSIONS,
    data: json,
    error
  };
}

export function requestDataExtensionColumns() {
  return {
    type: Constants.REQUEST_DATA_EXTENSION_COLUMNS
  };
}
export function receiveDataExtensionColumns(json, error) {
  return {
    type: Constants.RECEIVE_DATA_EXTENSION_COLUMNS,
    data: json,
    error
  };
}

export function buildRequestCreateDataExtensionImport(selected) {
  return () => {
    return {
      type: Constants.REQUEST_CREATE_DATA_EXTENSION_IMPORT,
      selectedDataExtension: selected
    };
  };
}
export function buildReceiveCreateDataExtensionImport({ importNow }) {
  return (json, error) => ({
    type: Constants.RECEIVE_CREATE_DATA_EXTENSION_IMPORT,
    data: { ...json, importNow },
    error
  });
}

export function getDataExtensions(search = null, options = {}) {
  const path = `ecs/api/data_extension?search=${encodeURIComponent(
    search || ''
  )}`;
  return new Endpoint(path, requestDataExtensions, receiveDataExtensions)
    .withOptions(options)
    .call();
}

export function getDataExtensionColumns(dataExtension, options = {}) {
  const path = `ecs/api/data_extension/${encodeURIComponent(
    dataExtension.customer_key
  )}/columns`;
  return new Endpoint(
    path,
    requestDataExtensionColumns,
    receiveDataExtensionColumns
  )
    .withOptions(options)
    .call();
}

export function createDataExtensionImport(
  dataExtension,
  schedule = null,
  notificationInfo = null,
  profileAttributes = null,
  importNow = 'true',
  options = {}
) {
  const subscriber_key_column =
    dataExtension.sendable_data_extension_field.name;
  let import_columns = profileAttributes.map(attr => {
    return {
      name: attr.name,
      data_type: attr.data_type,
      values: attr.values
    };
  });

  const name = dataExtension.name;
  const path = `ecs/api/data_extension/${dataExtension.customer_key}/import`;
  const body = {
    subscriber_key_column,
    import_columns,
    name,
    notification_email: notificationInfo.email || [],
    notify_on_success: notificationInfo.notify_on_success || false,
    notify_on_error: notificationInfo.notify_on_error || false,
    import_now: importNow.toString()
  };

  if (schedule) {
    body.hour = schedule.hour;
    body.am_pm = schedule.am_pm;
    body.minute = schedule.minute;
    body.time_zone = schedule.time_zone;
    body.sync_days = schedule.sync_days;
  }

  return new Endpoint(
    path,
    buildRequestCreateDataExtensionImport(dataExtension),
    buildReceiveCreateDataExtensionImport({ importNow })
  )
    .withMethod('POST')
    .withBody(JSON.stringify(body))
    .withOptions(options)
    .call();
}

export function createFtpImport(
  dataExtension,
  schedule = null,
  notificationInfo = null,
  ftpInfo = null,
  profileAttributes = null,
  importNow = 'false',
  options = {}
) {
  const subscriber_key_column =
    dataExtension.sendable_data_extension_field.name;
  let import_columns = profileAttributes.map(attr => {
    return {
      name: attr.name,
      data_type: attr.data_type,
      values: attr.values
    };
  });

  const name = dataExtension.name;
  const path = `ecs/api/ftp/${dataExtension.customer_key}/import`;
  const body = {
    subscriber_key_column,
    import_columns,
    name,
    file_name: ftpInfo.file_name,
    notification_email: notificationInfo.email || [],
    notify_on_success: notificationInfo.notify_on_success || false,
    notify_on_error: notificationInfo.notify_on_error || false,
    import_now: importNow.toString()
  };

  if (schedule) {
    body.hour = schedule.hour;
    body.am_pm = schedule.am_pm;
    body.minute = schedule.minute;
    body.time_zone = schedule.time_zone;
    body.sync_days = schedule.sync_days;
  }

  return new Endpoint(
    path,
    buildRequestCreateDataExtensionImport(dataExtension),
    buildReceiveCreateDataExtensionImport({ importNow })
  )
    .withMethod('POST')
    .withBody(JSON.stringify(body))
    .withOptions(options)
    .call();
}
